import classNames from 'classnames';
import { ReactNode } from 'react';

export default function TableRow(props: {
  className?: string;
  compact?: boolean;
  selected?: boolean;
  children?: ReactNode;
  onClick?: () => void;
  onAnimationEnd?: () => void;
}) {
  return (
    <tr
      onClick={props.onClick}
      onAnimationEnd={props.onAnimationEnd}
      className={classNames(
        'hover:bg-gray-50',
        props.compact ? 'h-8' : 'h-14',
        props.className,
        props.selected ? 'bg-indigo-50' : undefined
      )}
    >
      {props.children}
    </tr>
  );
}
